export default __webpack_public_path__ + "static/media/sleepy.5d4be6bd.mp3";